export const MEDIA_QUERY = {
  mobile: "(max-width: 1024px)",
  desktop: "(min-width: 1024px)",
  handset: "(max-width: 640px)",
  darkScheme: "(prefers-color-scheme: dark)",
} as const;
